function DotFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={8.795}
        cy={8.795}
        r={7.295}
        fill="#17D220"
        stroke="#fff"
        strokeWidth={3}
      />
    </svg>
  )
}

export default DotFilled
